import { uuid } from 'vue-uuid'
require('@/security.js')
var moment = require('moment')

export const messageMixin = {
  computed: {
    currentUser() {
      return this.$store.state.session.user
    },
    sortedConversationsComputed() {
      let convs = this.$store.state.conversation.conversations.slice()
      let groups = this.$store.state.group.groups.slice()
      let channels = this.$store.state.channel.channels.slice()
      
      for (let group of groups) {
        group.ConversationID = group.GroupID
        group.isGroupConversation = true
        group.isBuddyWriting = false
      }
      for (let channel of channels) {
        channel.ConversationID = channel.ChannelID
        channel.isChannelConversation = true
        channel.isBuddyWriting = false
      }
      let merged
      if (groups.length === 0 && channels.length === 0) {
        merged = convs
      } else {
        merged = convs.concat(groups).concat(channels)
      }

      merged.sort(function(a, b) {
        let aLast = a.LastMessage
        let bLast = b.LastMessage
        if (aLast === undefined || bLast === undefined) {
          return -1
        }
        if (a.isPinned && b.isPinned) {
          if (new Date(a.pinCreateDate).getTime() > new Date(b.pinCreateDate).getTime()) {
            return -1
          } else {
            return 1
          }
        }
        if (a.isPinned) {
          return -1
        }
        if (b.isPinned) {
          return 1
        }
        var aDate = a.LastMessage.UpdateDate == undefined || a.LastMessage.UpdateDate == null ? new Date(aLast.CreateDate) : new Date(aLast.UpdateDate)
        var bDate = b.LastMessage.UpdateDate == undefined || b.LastMessage.UpdateDate == null ? new Date(bLast.CreateDate) : new Date(bLast.UpdateDate)
        return bDate - aDate
      })

      const conversationIds = new Set()
      let mergedNoDuplicate = merged.filter(obj => {
        if (conversationIds.has(obj.ConversationID)) {
          return false
        }
        conversationIds.add(obj.ConversationID)
        return true
      })
      return mergedNoDuplicate
    }
  },
  methods: {
    makeBlob(url, name) {
      var vm = this
      var urlCopy = url
      return new Promise(function(resolve, reject) {
        // do a thing, possibly async, then…
        var str = vm.getBlob(name)
        if (str === 'blobNotFound') {
          if (!urlCopy.includes('gfe') && !urlCopy.includes('nophoto.png')) {
            var nameOfUrl = urlCopy.split('/')
            let key = '6a61e395-b49a-4468-bee0-27644e95308f'
            var iv = key
              .split('')
              .reverse()
              .join('')
            let encryptedBody = vm.ewk(nameOfUrl[nameOfUrl.length - 1], key, iv)
            url = process.env.VUE_APP_UPLOADURL2 + '/gf?fn=' + nameOfUrl[nameOfUrl.length - 1] + '&s=' + encodeURIComponent(encryptedBody)
          }
          //  vm.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
          vm.axios
            .get(url, {
              responseType: 'blob'
            })
            .then(response => {
              if (response.status === 200) {
                const urlx = window.URL.createObjectURL(new Blob([response.data]))
                var a = {
                  blobURL: urlx,
                  name: name
                }
                vm.$store.state.message.imageBlobs.push(a)
                resolve(urlx)
              } else {
                reject('It Broke')
              }
            })
            .catch(function(error) {
              console.log(error)
            })
          // vm.axios({
          //   url: url,
          //   method: 'GET',
          //   responseType: 'blob', // important,
          //   headers: {
          //     'Access-Control-Allow-Origin': '*',
          //     'Accept-Encoding': 'gzip, deflate, br'
          //   },
          // })
        } else {
          resolve(str)
        }
      })
    },
    getBlob(name) {
      var vm = this
      // var n = url.lastIndexOf('/');
      // var result = url.substring(n + 1);
      var control = vm.$store.state.message.imageRequestList.find(x => x === name)
      if (control !== undefined) {
        var blobURLObj = vm.$store.state.message.imageBlobs.find(x => x.name === name)
        if (blobURLObj === undefined || blobURLObj === null) {
          return ''
        } else {
          return blobURLObj.blobURL
        }
      } else {
        vm.$store.state.message.imageRequestList.push(name)
        return 'blobNotFound'
      }
    },
    enc(data) {
      let key = '0a34e8b3-d947-4379-a289-de33e8e2ac94'
      let iv = key
        .split('')
        .reverse()
        .join('')
      return this.ewk(data, key, iv)
    },
    setReadStatusOfActiveConversationMessages() {
      // let filteredMessages = this.$store.getters.activeConversationMessages
      // let store = this.$store

      // Filtering out messages sent by me, that are already read or that have undefined type
      // let nonReadMessages = filteredMessages.filter(
      //   msg => msg.From !== store.state.session.user.UserID && msg.Status < 3 && msg.MessageType !== 99
      // )

      // let msg
      // for (msg of nonReadMessages) {
      //   msg.Status = 3
      //   this.sendBackReadStatus(msg)
      // }

      let activeConversation = this.$store.state.conversation.activeConversation

      let conversationToRead = {}
      conversationToRead.UpdateDate =
        moment()
          .utc()
          .format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z' // MMMM Do YYYY, h:mm:ss
      conversationToRead.Status = 3

      var messagesToRead = []
      if (activeConversation.GroupID || activeConversation.ChannelID) {
        let uniqueId = activeConversation.GroupID || activeConversation.ChannelID
        messagesToRead = this.$store.state.messagestatus.messageStatuses.filter(ms => ms.UniqueID === uniqueId && ms.UserID === this.$store.state.session.user.UserID && ms.Status < 3)

        if (messagesToRead && messagesToRead.length > 0) {
          messagesToRead.forEach(mtr => {
            mtr.Status = 3
            var message = this.$store.state.message.messages.find(x => x.MessageID === mtr.MessageID)
            if (message !== undefined) {
              this.$set(message, 'Status', 3)
            }
          })

          conversationToRead.ContactID = ''
          conversationToRead.UniqueID = uniqueId
          conversationToRead.isGroup = !!activeConversation.GroupID
          conversationToRead.ConversationType = activeConversation.isChannelConversation ? 2 : 1
        }
      } else {
        messagesToRead = this.$store.state.message.messages.filter(m => m.ConversationID === activeConversation.ConversationID && m.From !== this.$store.state.session.user.UserID && m.Status < 3)

        if (messagesToRead && messagesToRead.length > 0) {
          messagesToRead.forEach(mtr => {
            mtr.Status = 3
          })

          conversationToRead.ContactID = activeConversation.ContactID
          conversationToRead.UniqueID = activeConversation.ConversationID
          conversationToRead.isGroup = false
        }
      }
      if (messagesToRead && messagesToRead.length > 0) {
        let readConversationMessage = {}
        readConversationMessage.Type = 'set'
        readConversationMessage.Task = 'update_conversation'
        readConversationMessage.From = this.$store.state.session.user.UserID
        readConversationMessage.Conversations = [conversationToRead]
        this.$store.state.socket.connection.send(this.enc(JSON.stringify(readConversationMessage)))
      }

      let element = this.$store.state.conversation.conversations.find(x => x.ConversationID === activeConversation.ConversationID)
      if (element !== undefined) {
        let ix = this.$store.state.conversation.conversations.indexOf(element)
        this.$store.state.conversation.conversations[ix].UnreadMessageCount = this.$store.getters.unreadMessagesCountOfConversation(this.$store.state.conversation.conversations[ix])
      } else {
        let el = this.$store.state.group.groups.find(x => x.GroupID === activeConversation.ConversationID)
        if (el !== undefined) {
          let i = this.$store.state.group.groups.indexOf(el)
          this.$store.state.group.groups[i].UnreadMessageCount = this.$store.getters.unreadMessagesCountOfConversation(this.$store.state.group.groups[i])
        } else {
          let ch = this.$store.state.channel.channels.find(x => x.ChannelID === activeConversation.ConversationID)
          let i = this.$store.state.channel.channels.indexOf(ch)
          if (i >= 0) {
            this.$store.state.channel.channels[i].UnreadMessageCount = this.$store.getters.unreadMessagesCountOfConversation(this.$store.state.channel.channels[i])
          }
        }
      }
    },

    setDeliverStatusOfConversationMessages() {
      const currentUserId = this.$store.state.session.user.UserID
      const messagesById = new Map()
      const directMessagesToDeliver = new Map()
      const sharedStatusesToDeliver = new Map()

      for (const message of this.$store.state.message.messages) {
        if (!messagesById.has(message.MessageID)) {
          messagesById.set(message.MessageID, message)
        }

        if (message.From !== currentUserId && message.Status < 2) {
          const messages = directMessagesToDeliver.get(message.ConversationID) || []
          messages.push(message)
          directMessagesToDeliver.set(message.ConversationID, messages)
        }
      }

      for (const messageStatus of this.$store.state.messagestatus.messageStatuses) {
        if (messageStatus.UserID === currentUserId && messageStatus.Status < 2) {
          const statuses = sharedStatusesToDeliver.get(messageStatus.UniqueID) || []
          statuses.push(messageStatus)
          sharedStatusesToDeliver.set(messageStatus.UniqueID, statuses)
        }
      }

      for (const activeConversation of this.sortedConversationsComputed) {
        let conversationToRead = {}
        conversationToRead.UpdateDate =
          moment()
            .utc()
            .format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z' // MMMM Do YYYY, h:mm:ss
        conversationToRead.Status = 2

        var messageToDeliver = []
        if (activeConversation.GroupID || activeConversation.ChannelID) {
          let uniqueId = activeConversation.GroupID || activeConversation.ChannelID
          messageToDeliver = sharedStatusesToDeliver.get(uniqueId) || []

          if (messageToDeliver && messageToDeliver.length > 0) {
            messageToDeliver.forEach(mtr => {
              mtr.Status = 2
              var message = messagesById.get(mtr.MessageID)
              if (message !== undefined) {
                this.$set(message, 'Status', 2)
              }
            })

            conversationToRead.ContactID = ''
            conversationToRead.UniqueID = uniqueId
            conversationToRead.isGroup = !!activeConversation.GroupID
            conversationToRead.ConversationType = activeConversation.isChannelConversation ? 2 : 1
          }
        } else {
          messageToDeliver = directMessagesToDeliver.get(activeConversation.ConversationID) || []

          if (messageToDeliver && messageToDeliver.length > 0) {
            messageToDeliver.forEach(mtr => {
              mtr.Status = 2
            })

            conversationToRead.ContactID = activeConversation.ContactID
            conversationToRead.UniqueID = activeConversation.ConversationID
            conversationToRead.isGroup = false
          }
        }
        if (messageToDeliver && messageToDeliver.length > 0) {
          let readConversationMessage = {}
          readConversationMessage.Type = 'set'
          readConversationMessage.Task = 'update_conversation'
          readConversationMessage.From = this.$store.state.session.user.UserID
          readConversationMessage.Conversations = [conversationToRead]
          this.$store.state.socket.connection.send(this.enc(JSON.stringify(readConversationMessage)))
        }
      }
    },

    sendMessage(newMsg) {
      var item = this.$store.state.conversation.conversations.find(x => x.ConversationID == this.$store.state.conversation.activeConversation.ConversationID)
      if (item != null) {
        item.LastMessage = newMsg
      } else {
        var group = this.$store.state.group.groups.find(x => x.GroupID == this.$store.state.conversation.activeConversation.ConversationID)
        if (group != null) {
          group.LastMessage = newMsg
        } else {
          var channel = this.$store.state.channel.channels.find(x => x.ChannelID == this.$store.state.conversation.activeConversation.ConversationID)
          if (channel != null) {
            channel.LastMessage = newMsg
          }
        }
      }
      // this.$set(newMsg,'mv',2)// burası encrypt için
      if (this.$store.state.socket.connection.readyState === 1 && this.$store.state.isConnected) {
        // We only attempt to send the message if there is a connection available, otherwise save the message to unsentMessages array for retrying later
        this.$store.state.socket.connection.send(this.enc(JSON.stringify(newMsg)))

        if (newMsg.ConversationType === 2) {
          newMsg.Status = 1
        } else if (!newMsg.isGroup) {
          newMsg.Status = 1
        } else {
          let GroupID = newMsg.To
          let group = this.$store.state.group.groups.find(g => g.GroupID === GroupID)
          var groupMembers = []
          let groupOwner = group.Owner
          let groupAdmins = group.Admins
          let groupParticipants = group.Participants

          groupMembers.push(groupOwner)
          if (groupAdmins) {
            groupAdmins.forEach(ga => groupMembers.push(ga))
          }
          groupParticipants.forEach(gp => groupMembers.push(gp))

          var deliveryDate =
            moment()
              .utc()
              .format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z' // MMMM Do YYYY, h:mm:ss
          groupMembers = groupMembers.filter(gm => gm !== this.$store.state.session.user.UserID)
          groupMembers.forEach(gm => {
            let groupMessageStatus = {}
            groupMessageStatus.UserID = gm
            groupMessageStatus.GroupID = GroupID
            groupMessageStatus.MessageID = newMsg.MessageID
            groupMessageStatus.DeliverDate = deliveryDate
            groupMessageStatus.UpdateDate = deliveryDate
            groupMessageStatus.SeenDate = null
            groupMessageStatus.Status = 1
            groupMessageStatus.UniqueID = GroupID

            this.$store.state.messagestatus.messageStatuses.push(groupMessageStatus)
          })
        }
      } else {
        this.$store.state.message.unsentMessages.push(newMsg)
      }
    },
    sendDeleteMessage(message, messageStatus) {
      var data = {}
      data.Type = 'set'
      data.Task = 'delete_message'
      data.MessageID = message.MessageID
      data.From = message.From
      data.DeleteStatus = message.Status
      if (message.isGroup) {
        data.UniqueID = message.To
      } else {
        data.UniqueID = message.ConversationID
      }
      data.isGroup = message.isGroup
      data.To = message.To

      this.$store.state.socket.connection.send(this.enc(JSON.stringify(data)))
    },
    updateMessageStatus(message, messageStatus) {
      if (message.From === this.$store.state.session.user.UserID) {
        return
      }
      var data = {}
      data.Type = 'set'
      data.Task = 'ums'
      data.MessageID = message.MessageID
      data.Owner = message.From
      data.Status = message.Status
      data.From = this.$store.state.session.user.UserID
      data.UserID = this.$store.state.session.user.UserID
      if (message.isGroup) {
        data.UniqueID = message.To
      } else {
        data.UniqueID = message.ConversationID
      }
      data.isGroup = message.isGroup
      if (message.Status === 2) {
        data.DeliverDate =
          moment()
            .utc()
            .format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z'
      } else if (message.Status === 3) {
        data.SeenDate =
          moment()
            .utc()
            .format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z'
      }
      data.DeliverDate = message.UpdateDate
      this.$store.state.socket.connection.send(this.enc(JSON.stringify(data)))
    },

    deleteMessage(message) {
      message.Status = 11
      if (this.$store.state.ien) {
        var key = message.From + message.To
        var iv = key
          .split('')
          .reverse()
          .join('')
        let encryptedBody = this.ewk(message.Body, key, iv)
        message.Body = encryptedBody
      }
      this.$store.commit('deleteMessage', message)
      this.sendDeleteMessage(message)
    },

    permanentDeleteMessage(message) {
      this.$set(message, 'DeleteStatus', 12)
      this.$set(message, 'Status', 12)
      // message.Status = 12
      if (this.$store.state.ien) {
        var key = message.From + message.To
        var iv = key
          .split('')
          .reverse()
          .join('')
        let encryptedBody = this.ewk(message.Body, key, iv)
        message.Body = encryptedBody
      }
      this.$store.commit('deleteMessage', message)
      this.sendDeleteMessage(message)
    },
    clearOrRemoveChat(conversation, isRemove) {
      let sortedMessages = this.$store.getters.sortedMessagesOfConv(conversation)
      let data = {}
      data.Type = 'set'
      data.Task = 'clear_chat'
      data.From = this.$store.state.session.user.UserID
      if (conversation.isGroupConversation) {
        data.UniqueID = conversation.GroupID
      } else if (conversation.isChannelConversation) {
        data.UniqueID = conversation.ChannelID
      } else {
        data.UniqueID = conversation.ConversationID
      }

      data.ClearDate =
        sortedMessages.length === 0
          ? moment()
              .utc()
              .format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z'
          : sortedMessages[sortedMessages.length - 1].CreateDate
      data.isRemove = isRemove
      if (conversation.isGroupConversation) {
        data.isGroup = true
      } else if (conversation.isChannelConversation) {
        data.isGroup = false
        data.ConversationType = 2
      } else {
        data.isGroup = false
      }

      this.$store.state.socket.connection.send(this.enc(JSON.stringify(data)))
      if (isRemove) {
        if (conversation.isGroupConversation) {
          this.$store.state.group.groups = this.$store.state.group.groups.filter(x => x.GroupID !== conversation.ConversationID)
          this.$store.state.message.messages = this.$store.state.message.messages.filter(x => x.To !== conversation.ConversationID)
        } else if (conversation.isChannelConversation) {
          this.$store.state.channel.channels = this.$store.state.channel.channels.filter(x => x.ChannelID !== conversation.ConversationID)
          this.$store.state.message.messages = this.$store.state.message.messages.filter(x => x.To !== conversation.ConversationID)
        } else {
          this.$store.state.conversation.conversations = this.$store.state.conversation.conversations.filter(x => x.ConversationID !== conversation.ConversationID)

          this.$store.state.message.messages = this.$store.state.message.messages.filter(x => x.ConversationID !== conversation.ConversationID)
        }
      } else {
        let item
        if (conversation.isGroupConversation) {
          item = this.$store.state.group.groups.find(x => x.GroupID === conversation.ConversationID)
          item.LastMessage.body = ''
          this.$store.state.message.messages = this.$store.state.message.messages.filter(x => x.To !== conversation.ConversationID)
        } else if (conversation.isChannelConversation) {
          item = this.$store.state.channel.channels.find(x => x.ChannelID === conversation.ConversationID)
          item.LastMessage = {}
          this.$store.state.message.messages = this.$store.state.message.messages.filter(x => x.To !== conversation.ConversationID)
        } else {
          item = this.$store.state.conversation.conversations.find(x => x.ConversationID === conversation.ConversationID)
          item.LastMessage = ''
          this.$store.state.message.messages = this.$store.state.message.messages.filter(x => x.ConversationID !== conversation.ConversationID)
        }
      }
    },
    toggleReaction(message, emoji) {
      let data = {}
      data.Type = 'set'
      data.Task = 'toggle_reaction'
      data.From = this.$store.state.session.user.UserID
      data.MessageID = message.MessageID
      data.Emoji = emoji
      // ConversationType belirle
      const activeConv = this.$store.state.conversation.activeConversation
      if (activeConv && activeConv.isGroupConversation) {
        data.ConversationType = 1
        data.To = message.To
      } else if (activeConv && activeConv.isChannelConversation) {
        data.ConversationType = 2
        data.To = message.To
      } else {
        data.ConversationType = 0
        // 1-to-1: To her zaman karşı taraf olmalı
        data.To = (message.From === data.From) ? message.To : message.From
      }

      this.$store.state.socket.connection.send(this.enc(JSON.stringify(data)))
    },

    starMessage() {
      let data = {}
      data.Type = 'set'
      data.Task = 'set_stars'
      data.From = this.$store.state.session.user.UserID
      data.MessageIDs = [] // TODO: messageID'ler buraya gelecek.
      for (const iterator of this.$store.state.message.starredMessages) {
        data.MessageIDs.push(iterator.MessageID)
      }
      this.$store.state.socket.connection.send(this.enc(JSON.stringify(data)))
    },

    editMessage(message, newBody, mentions = []) {
      // Şifreleme (normal mesajlardaki em mantığı)
      let encryptedBody = newBody
      if (this.$store.state.ien) {
        var key, iv
        if (message.mv === 2) {
          // mv=2: karmaşık key
          var messageID = message.MessageID
          var last1Char = messageID.charAt(messageID.length - 1)
          var last2Char = messageID.charAt(messageID.length - 2)
          var last1 = last1Char.charCodeAt(0) % 5
          var last2 = last2Char.charCodeAt(0) % 5
          var parts = messageID.split('-')
          key = message.From + parts[last1] + parts[last2] + 'da81b159-a8d1-4f56-90b7-914d1a561bb0' + message.To
        } else {
          // mv!=2: basit key
          key = message.From + message.To
        }
        iv = key.split('').reverse().join('')
        encryptedBody = this.ewk(newBody, key, iv)
      }

      // Socket üzerinden gönder
      let data = {}
      data.Type = 'set'
      data.Task = 'edit_message'
      data.MessageID = message.MessageID
      data.From = message.From
      data.To = message.To
      data.Body = encryptedBody
      data.mv = message.mv
      data.isGroup = message.isGroup
      data.Mentions = Array.isArray(mentions) ? mentions : []
      if (message.isGroup) {
        data.UniqueID = message.To
      } else {
        data.UniqueID = message.ConversationID
      }

      this.$store.state.socket.connection.send(this.enc(JSON.stringify(data)))

      // Lokal olarak mesajı güncelle (şifresiz hali)
      let messageToEdit = this.$store.state.message.messages.find(m => m.MessageID === message.MessageID)
      if (messageToEdit) {
        this.$set(messageToEdit, 'Body', newBody)
        this.$set(messageToEdit, 'IsEdited', true)
        this.$set(messageToEdit, 'Mentions', data.Mentions)
      }
    },

    getUserNameDisplay(userID) {
      let user = this.$store.getters.getUserById(userID)
      if (!user || !user.VisibleName) {
        return ''
      } else {
        return user.VisibleName
      }
    },

    interpretedInfoMessage(message) {
      let output = message
      let sender = this.getUserNameDisplay(message.From)
      let body = JSON.parse(message.Body)
      let isLDAPGroup = false
      if (message.isGroup) {
        let group = this.$store.state.group.groups.find(g => g.GroupID === message.To)
        isLDAPGroup = group.isLDAPGroup
      }

      let sentencePrefix = ''
      let sentenceTarget = ''
      let sentenceSuffix = ''

      if (body.Type === 0) {
        if (isLDAPGroup) {
          sentenceSuffix = ' grubu oluşturuldu.'
        } else if (message.From !== this.$store.state.session.user.UserID) {
          sentencePrefix = sender
          sentenceSuffix = ' grubunu oluşturdu.'
        } else {
          sentenceSuffix = ' grubunu oluşturdunuz.'
        }
        sentenceTarget = body.GroupName
      } else {
        let targetNames = body.To.map(x => this.getUserNameDisplay(x))
        let peopleString = targetNames.length > 1 ? 'kişilerini' : 'kişisini'

        if (isLDAPGroup) {
          peopleString = targetNames.length > 1 ? 'kişileri' : 'kişisi'
          let actionName = body.Type === 1 ? ' eklendi.' : ' çıkarıldı.'
          sentenceSuffix = peopleString + actionName
        } else if (message.From !== this.$store.state.session.user.UserID) {
          sentencePrefix = sender
          let actionName = body.Type === 1 ? ' ekledi.' : ' çıkardı.'
          sentenceSuffix = peopleString + actionName
        } else {
          let actionName = body.Type === 1 ? ' eklediniz.' : ' çıkardınız.'
          sentenceSuffix = peopleString + actionName
        }
        sentenceTarget = targetNames.join(', ')
      }
      output = sentencePrefix + ' "' + sentenceTarget + '" ' + sentenceSuffix
      return output
    },

    interpretedUnasweredCallMessage(message) {
      let output = message
      let sender = this.getUserNameDisplay(message.From)
      let body = JSON.parse(message.Body)

      let sentenceTarget = ''
      let sentenceSuffix = ''
      if (body.type === 'audio') {
        sentenceSuffix = 'Cevapsız Sesli Arama ' + moment(message.UpdateDate).format('HH:mm')
      } else if (body.type === 'video') {
        sentenceSuffix = 'Cevapsız Görüntülü Arama ' + moment(message.UpdateDate).format('HH:mm')
      }

      output = sentenceSuffix
      return output
    },

    interpretedDateMessage(message) {
      let output = message
      output = moment(message.CreateDate).format('DD.MM.YYYY')
      let today = moment().format('DD.MM.YYYY')
      let yesterday = moment()
        .subtract(1, 'days')
        .format('DD.MM.YYYY')
      if (output === today) {
        output = 'BUGÜN'
      } else if (output === yesterday) {
        output = 'DÜN'
      }
      return output
    },

    userColor(userID) {
      let userColorObj = this.$store.state.display.messages.userColors.find(us => us.userID === userID)
      if (userColorObj === undefined) {
        userColorObj = {}
        userColorObj.userID = userID
        userColorObj.color = '#' + Math.floor(Math.random() * 16777215).toString(16)
        this.$store.state.display.messages.userColors.push(userColorObj)
      }
      return userColorObj.color
    },

    getMessageDate() {
      return this.message.CreateDate
    }
  }
}
